export default __webpack_public_path__ + "8f5a30593d6962a15ad631ae9b5fb3aa.svg";